import { render, staticRenderFns } from "./vcNotificationPromotions.vue?vue&type=template&id=1b15b942&scoped=true&"
import script from "./vcNotificationPromotions.vue?vue&type=script&lang=js&"
export * from "./vcNotificationPromotions.vue?vue&type=script&lang=js&"
import style0 from "./vcNotificationPromotions.vue?vue&type=style&index=0&id=1b15b942&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b15b942",
  null
  
)

export default component.exports